import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
  Directive,
  EventEmitter,
  Output
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { AlertsService } from "angular-alert-module";
import {
  AuthenticationService,
  TokenPayload
} from "src/app/services/authentication.service";
import { Endtest, endtestService } from "src/app/services/endtest.service";
import { TestTakerService } from "src/app/services/test_taker.service";
interface Alert {
  type: string;
  message: string;
}
declare var $: any;
declare let jQuery: any;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  capsOn;
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("login") modalLogin: TemplateRef<any>;
  loginForm: FormGroup;
  showModal5: boolean;
  showModal1: boolean;
  showModal2: boolean;
  showModal: boolean;
  // Form controls
  email = new FormControl("", [Validators.required]);
  password = new FormControl("", [Validators.required]);
  islogged: Endtest = {
    Id: "",
    Test_Taker_User_Id: "",
    Is_Logged: "",
    login_time: "",
    logoff_time: "",
    schedule_master_Id: ""
  };
  completed: boolean = false;
  scheduled: boolean = false;
  badrequest: boolean = false;
  showForgetPassword: boolean = false;
  loginError: boolean;
  credentials: TokenPayload = {
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    // confirmpassword: '',
    phone: "",
    type: ""
    // clientTime: new Date(),
    // clientTimezone: ''
  };
  logged: boolean;
  modalRef: any;
  invalid_credentials: boolean = false;
  expiry: boolean = false;
  isLoading :boolean = false;
  role: any;


  //added
  isDetailsRequired: boolean;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private alerts: AlertsService,
    private Endtest: endtestService,
    private ts: TestTakerService,
    private modal: NgbModal
  ) {}

  ngOnInit() {
    console.log("inside login", !this.email.value);

    this.loginForm = this.formBuilder.group({
      email: this.email,
      password: this.password
    });
    jQuery(document).ready(function($) {
      if (navigator.userAgent.indexOf("Firefox") != -1) {
        if (window.history && window.history.pushState) {
          $(window).on("popstate", function() {
            var hashLocation = location.hash;
            var hashSplit = hashLocation.split("#!/");
            var hashName = hashSplit[1];

            if (hashName !== "") {
              var hash = window.location.hash;
            }
          });
          window.history.pushState("/", null, "./");
        }
      }
    });
  }

  getEmail(event) {
    console.log("event", event.target.value);
    let email = event.target.value;
    this.auth.checkEmail(email).subscribe(
      data => {
       
        console.log("results", data);
        if (data.code === 200) {
          
          this.showForgetPassword = true;
        } else if (data.code === 400) {
          this.showForgetPassword = false;
        }
    
      },
      err => {
        this.errorMsg =
          err.msg === "invalid mail" ? "Invalid Email Id" : "Password Mismatch";
      }
    );
  }

  forgetPassword() {
    this.router.navigateByUrl(`/forgot_password`);
  }

  errorMsg: string;
  @HostListener("window:popstate", ["$event"])
  onBrowserBackBtnClose(event: Event) {
    event.preventDefault();

    this.router.navigate(["/final"], { replaceUrl: true });
  }
  @HostListener("contextmenu", ["$event"])
  onRightClick(event) {
    event.preventDefault();
  }

  async login() {
    //
    this.scheduled = false;
    this.loginError = false;
    this.completed = false;
    this.badrequest = false;
    this.expiry = false;
    this.invalid_credentials = false;
    this.isLoading = true;
    // await this.checkTestSchedule();
    console.log("this.credentials****", this.credentials);
    this.auth.login(this.credentials).subscribe(
      
      async data => {
       
        console.log("results", data);
        localStorage.clear();
        localStorage.setItem("jwt_token", data.jwt_token);
        this.role = data.role;

        if (data.code === 404) {
          console.log("404")
          this.isLoading=false;
          this.loginError = true;
          //alert(data.failed);
        } else if (data.code === 503) {
          //alert('Not yet scheduled');
          console.log("503")
          this.isLoading=false;
          this.scheduled = true;
        } else if (data.code === 302) {
          console.log("302")
          this.isLoading=false;
          this.completed = true;
        } else if (data.code === 400) {
          console.log("400")
          this.isLoading=false;
          this.badrequest = true;
        } else if (data.code === 401) {
          console.log("401")
          this.isLoading=false;
          this.invalid_credentials = true;
        } else if (data.code === 502) {
          console.log("502")
          this.isLoading=false;
          this.expiry = true;
        } else if (this.role === 1) {
          localStorage.setItem("jwt_token", data.jwt_token);
          sessionStorage.setItem("user", "1");
          sessionStorage.setItem("fname", data.results.first_name);
          sessionStorage.setItem("lname", data.results.last_name);

          this.router.navigateByUrl("/super_admin");
        } else if (this.role === 2) {
          sessionStorage.setItem("user", "2");
          sessionStorage.setItem("fname", data.results.first_name);
          sessionStorage.setItem("lname", data.results.last_name);
          this.router.navigateByUrl("/test_evaluation");
        } else if (this.role === 3) {
          sessionStorage.setItem("user", "3");
          sessionStorage.setItem("fname", data.results.first_name);
          sessionStorage.setItem("lname", data.results.last_name);
          this.router.navigateByUrl("/upload_question_bank");
        } else if (this.role === 4) {
          sessionStorage.setItem("user", "4");

          sessionStorage.setItem("id", data.results[0].Id);
          sessionStorage.setItem("email", data.results[0].email);
          sessionStorage.setItem("fname", data.results[0].first_name);
          sessionStorage.setItem("lname", data.results[0].last_name);
          sessionStorage.setItem("Paper_Id", data.results[0].Question_Paper_Id);
          sessionStorage.setItem("Set_Id", data.results[0].Question_Set_Id);
          sessionStorage.setItem("Schedule_Id", data.results[0].scheduleId);
          sessionStorage.setItem(
            "Schedule_Master_Id",
            data.results[0].Schedule_Master_Id
          )

          await this.checkUserDetailsRequired(data.results[0].isRequired,data.results[0].isFormSubmitted);

          this.updatelogin();
        }
      },
      err => {
        this.isLoading=false;
        
        this.errorMsg =
          err.msg === "invalid mail" ? "Invalid Email Id" : "Password Mismatch";
          
      }
    );
  }

  // changepassword() {
  //   // this.router.navigateByUrl('/change_password')
  // }
  // resetpassword() {

  // }
  async checkUserDetailsRequired(isRequired: number,isFilled:number) {

    console.log(isRequired,isFilled, "data from db");
    if (isRequired === 0 || isFilled===1 ) {
      this.isLoading = false;
      console.log("inside not needed");
      this.router.navigateByUrl("/take_snapshot");
    } else {
      this.isLoading = false;
      console.log("inside needed");
      this.router.navigateByUrl("/user_details_form");
    }
  }

  updatelogin() {
    console.log("inside update login");
    this.islogged.schedule_master_Id = sessionStorage.getItem(
      "Schedule_Master_Id"
    );
    var user_id = sessionStorage.getItem("id");
    var schedule_id = sessionStorage.getItem("Schedule_Id");

    this.Endtest.updatelogin(this.islogged, user_id, schedule_id).subscribe(
      data1 => {},
      err => {
        //console.error(err);
      }
    );
  }
}

@Directive({ selector: "[capsLock]" })
export class TrackCapsDirective {
  @Output("capsLock") capsLock = new EventEmitter<Boolean>();

  @HostListener("window:keydown", ["$event"])
  onKeyDown(event: KeyboardEvent): void {
    this.capsLock.emit(
      event.getModifierState && event.getModifierState("CapsLock")
    );
  }
  @HostListener("window:keyup", ["$event"])
  onKeyUp(event: KeyboardEvent): void {
    this.capsLock.emit(
      event.getModifierState && event.getModifierState("CapsLock")
    );
  }
}